import { ComponentPropsWithoutRef } from "react";
import clsx from "clsx";
import * as iconStyles from "./Icons.css";

// Material Design icon values from backend schema (apps/backend/schemaTypes/objects/global/icons.tsx)
// @ts-expect-error - SVG react component imports
import Domain from "@material-design-icons/svg/filled/domain.svg?react";
// @ts-expect-error - SVG react component imports
import VolunteerActivism from "@material-design-icons/svg/filled/volunteer_activism.svg?react";
// @ts-expect-error - SVG react component imports
import Inventory2 from "@material-design-icons/svg/filled/inventory_2.svg?react";
// @ts-expect-error - SVG react component imports
import Construction from "@material-design-icons/svg/filled/construction.svg?react";
// @ts-expect-error - SVG react component imports
import Diversity3 from "@material-design-icons/svg/filled/diversity_3.svg?react";
// @ts-expect-error - SVG react component imports
import ImportContacts from "@material-design-icons/svg/filled/import_contacts.svg?react";
// @ts-expect-error - SVG react component imports
import Visibility from "@material-design-icons/svg/filled/visibility.svg?react";
// @ts-expect-error - SVG react component imports
import Share from "@material-design-icons/svg/filled/share.svg?react";
// @ts-expect-error - SVG react component imports
import PrivacyTip from "@material-design-icons/svg/filled/privacy_tip.svg?react";

const iconMap = {
  domain: Domain,
  volunteer_activism: VolunteerActivism,
  inventory_2: Inventory2,
  construction: Construction,
  diversity_3: Diversity3,
  import_contacts: ImportContacts,
  visibility: Visibility,
  share: Share,
  privacy_tip: PrivacyTip,
} as const;

export type IconValue = keyof typeof iconMap;

export interface IconsProps extends ComponentPropsWithoutRef<"span"> {
  /** Icon value from Sanity icons schema (Building, Hand Heart, Inventory, etc.) */
  value: IconValue | string | null | undefined;
  /** Optional size in pixels (default: 24) */
  size?: number;
}

export const Icons = ({
  value,
  size = 24,
  className,
  ...props
}: IconsProps) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  const IconComponent = iconMap[value as IconValue];
  if (!IconComponent) {
    return null;
  }

  return (
    <span
      className={clsx((iconStyles as { wrapper: string }).wrapper, className)}
      style={{ width: size, height: size }}
      aria-hidden
      {...props}
    >
      <IconComponent style={{ width: size, height: size }} />
    </span>
  );
};
